import React, {Component} from 'react'

import Navbar from '../Navbar'
import PoweredByKensho from '../PoweredByKensho'

import './styles.css'

class Page extends Component {
  render() {
    const {style, about, onAboutClicked} = this.props
    const touch = ('ontouchstart' in document) ? 'touch' : 'no-touch'
    return (
      <div className={`page touch-either ${touch}`} style={style}>
        <div className="page-inner">
          <Navbar onAboutClicked={onAboutClicked} about={about} />
          <div className="page-rest">
            {this.props.children}
          </div>
          <PoweredByKensho />
        </div>
      </div>
    )
  }
}

export default Page



// WEBPACK FOOTER //
// ./src/components/Page/index.js